import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateTimelineItem = document.createElement('template');

templateTimelineItem.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
    <div id="icon-title" class="timeline-item-container icon ">
        <div class="timeline-item-inner">
           <div class="secondary-title-element-container">
                <gz-tooltip class="alertTitle-tooltip">
                   <gz-text id="alertTitle" fontSize="14" fontWeight="500" lineheight="1.3">URL.Malicious</gz-text>
                </gz-tooltip>

                 <gz-tooltip class="killChainStep-tooltip">
                        <gz-text id="killChainStep" fontSize="14" lineheight="1.0">Initial access</gz-text>
                  </gz-tooltip>

    </div>
    <div class="severity-container">
    <gz-text id="severity-label" class="severity-label" fontsize="12" fontWeight="400"></gz-text>
    <gz-text id="severity" class="severity-value" fontsize="12" fontWeight="400"></gz-text>
    </div>
        <gz-text id="alertDescription" fontSize="12" fontWeight="400">Unwanted activity has been detected while accessing a URL.</gz-text>
        <div class="sensor-container">
           <gz-text id="sensor" class="sensor-label" fontSize="12" fontWeight="400">Detected by Endpoint Sensor on </gz-text>
        </div>
        <div class="impact-container">
           <gz-text id="numberOfEndpoints" fontSize="8">
                <div class="icon icon-endpoint">
                    <span  class="value">4</span>
                </div>
           </gz-text>

           <gz-text id="numberOfServers" fontSize="8">
                <div class="icon icon-servers">
                    <span  class="value">4</span>
                </div>
           </gz-text>

           <gz-text id="numberOfInternalEmails" fontSize="8">
                <div class="icon icon-mail">
                    <span  class="value">4</span>
                </div>
           </gz-text>

           <gz-text id="numberOfIps" fontSize="8">
                <div class="icon icon-domain">
                    <span  class="value">4</span>
                </div>
           </gz-text>

           <gz-text id="numberOfIdentities" fontSize="8">
                <div class="icon icon-user">
                    <span  class="value">4</span>
                </div>
           </gz-text>
        </div>
        <gz-link id="identicalTactic" color="primary"></gz-link>
       </div>
    </div>
    <div class="wrapper">

    </div>
`;
